var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPunishDissenters2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 58,
    viewBox: "0 0 61 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 3C45.3594 3 57 14.6407 57 29C57 43.3594 45.3594 55 31 55C16.6406 55 5 43.3594 5 29C5 14.6407 16.6406 3 31 3Z",
    stroke: "#E3000F",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3103 37.9283C38.796 37.9283 45.675 39.3615 45.675 41.1296C45.675 42.8974 38.796 44.3306 30.3103 44.3306C21.8244 44.3306 14.9453 42.8974 14.9453 41.1296C14.9453 39.3615 21.8244 37.9283 30.3103 37.9283Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3103 37.9283C38.796 37.9283 45.675 39.3615 45.675 41.1296C45.675 42.8974 38.796 44.3306 30.3103 44.3306C21.8244 44.3306 14.9453 42.8974 14.9453 41.1296C14.9453 39.3615 21.8244 37.9283 30.3103 37.9283Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 19.2213H45.4058V41.7692H14.625V19.2213Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0159 15.8623C38.5018 15.8623 45.3809 17.2955 45.3809 19.0636C45.3809 20.8312 38.5018 22.2644 30.0159 22.2644C21.5302 22.2644 14.6514 20.8312 14.6514 19.0636C14.6514 17.2955 21.5302 15.8623 30.0159 15.8623Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0159 15.8623C38.5018 15.8623 45.3809 17.2955 45.3809 19.0636C45.3809 20.8312 38.5018 22.2644 30.0159 22.2644C21.5302 22.2644 14.6514 20.8312 14.6514 19.0636C14.6514 17.2955 21.5302 15.8623 30.0159 15.8623Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-411 -830)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPunishDissenters2);
export default __webpack_public_path__ + "static/media/punish_dissenters2.e5ea93f271a3971298a73769dd7eb26f.svg";
export { ForwardRef as ReactComponent };